export default __webpack_public_path__ + "static/media/lowFees.67cffb51.png";